/** A method to create type-guard for string unions */
export const guard = (array) => (value) => array.includes(value);
